import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import pelak from '../../assets/img/pelak.png';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'url("' + pelak + '")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    width: '100%',
    height: 50,
    display: 'flex',
    flexFlow: 'row nowrap',
    padding: theme.spacing(1),
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(2),
    },
  },
  cityCode: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  firstCode: {
    fontSize: 24,
  },
  alphabetCode: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  secondCode: {
    fontSize: 24,
  },
}));

const DriverPlate = ({ driver }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.cityCode}>{driver.numberPlate.cityCode}</div>
      <div className={classes.firstCode}>{driver.numberPlate.firstCode}</div>
      <div className={classes.alphabetCode}>
        {driver.numberPlate.alphabetCode}
      </div>
      <div className={classes.secondCode}>{driver.numberPlate.secondCode}</div>
    </div>
  );
};

export default React.memo(DriverPlate);
